<div id="teacher-dashboard">
  <div class="dashboard-container" [class.is-mobile]="isMobile">
    <!-- [sideNav]="sideNav" -->
    <app-header (height)="onGetHeight($event)"></app-header>
    <mat-sidenav-container class="sidenav-container min-height-chat">
      <!-- Start SideNav -->
      <mat-sidenav
        #sideNav
        [mode]="isMobile ? 'over' : 'side'"
        [fixedInViewport]="isMobile"
        [fixedTopGap]="headerHeight"
        [opened]="!isMobile"
      >
        <div id="customSideNav" *ngIf="!isMobile">
          <app-chat-list></app-chat-list>
        </div>
      </mat-sidenav>
      <!-- End SideNav -->

      <mat-sidenav-content id="messages-content" style="overflow: scroll">
        <div [ngSwitch]="isMobile"  id="messages-content-child">
          <ng-container *ngSwitchCase="true">
            <!-- list -->
            <app-chat-list *ngIf="!chatSelected"></app-chat-list>
            <app-chat-conversation
              *ngIf="chatSelected"
              [chatSelected]="chatSelected"
            ></app-chat-conversation>
          </ng-container>
          <ng-container *ngSwitchCase="false">
            <!-- Messages -->
            <div *ngIf="chatSelected; else noChatSelectedTemplate">
              <app-chat-conversation
                [chatSelected]="chatSelected"
              ></app-chat-conversation>
            </div>
          </ng-container>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>

<ng-template #noChatSelectedTemplate>
  <div class="flex-center margin-top-1">
    {{ "no-chat-selected" | translate }}
  </div>
</ng-template>

<app-loading [loading]="loading"></app-loading>
